export default {"src":"/bnb/_next/static/media/deri.8ea1e8bb.svg","height":22,"width":18};